export const formatPhone = (phone) => {
  if (phone?.length !== 11) {
    return undefined;
  }

  const fPhone = phone.replace(/\d(?=(?:\D*\d){3})/g, "*").substring(2, 11);

  return "09" + fPhone;
};
